'use strict';

import $ from 'jquery';

// Av ngn magisk anledning måste denna importeras, även om den inte anv av denna kod. Har kanske att göra med att det är jQuery och inte 'äkta' modulariserat?
// eslint-disable-next-line no-unused-vars
import dt from 'datatables.net';

// Denna används för DataTables-kolumnernas index 0–n (enum-medlemmarnas värden) i datavektorn *och* tabellen:
// Provar här en metod att få "enum" i JavaScript:
const KolumnEnum = Object.freeze({
	DATUM: 0,
	BESKRIVNING: 1,
	VERIFIKAT: 2,
	EU: 3,
	KST: 4,
	PROJ: 5,
	RESKFORT: 6,
	BELOPP: 7,
	SALDO: 8,
	ISRADTEXT: 9,
	RADTEXT: 10
});


/*let datatable = */
let initiera = function(dataTableData, harReskEllerFort, antalDoldaKolumner) {
		
	return $('#_ss-tabellen_kropp').DataTable({

		data: dataTableData,

		ordering: false,
		/*order: [[0, 'asc']],*/

		dom: 't',	/* Se https://datatables.net/reference/option/dom */
		searching: true,
		/* Sätt den initiala filtreringen: */
		/* Kan även göras med API, så här: tabellen.column(5).search('true').draw(); och '' invaliderar filtret. */
		searchCols: [
			null
			, null
			, null
			, null
			, null
			, null
			, null
			, null
			, null
			, { search: '' }	// Initialt visas radtexter.
			, null
		],

		language: {
			loadingRecords: 'Laddar...',
			processing: 'Bearbetar...',
			emptyTable: 'Inga transaktioner att visa',
			zeroRecords: 'Inga transaktioner matchar ditt filter &nbsp; :('	/* Avser endast filtreringsresultatet! */
		},
		paging: false,
		info: false,
		processing: false,
		autoWidth: false,
		deferRender: true,

		// Arghh! Denna sparar, och återställer, även kolumners visibilitet, vilket *inte* funkar så bra ihop med vårt sätt att hantera kst+proj- eller reskfort-kolumnerna med visible: false. Avstängt tills vidare:
		stateSave: false,
		/* Kan invalideras med tabellen.state.clear(); */

		/*stripeClasses: [ 'ss-udda', 'ss-jamn' ],*/

		responsive: false,	/* Extension som vi inte anv f.n. */

				//, {
				//	name: 'verifikat'
				//	, targets: 2
				//	, render(data, type, row) {
				//		return (row[9] === null ? data : '<a href='/verifikat/' + row[9] + ''>' + data + '</a>');
				//	}
				//}

		columnDefs: [
			{ name: 'datum', targets: KolumnEnum.DATUM }
			, { name: 'beskrivning', targets: KolumnEnum.BESKRIVNING, className: 'nw' }
			, { name: 'verifikat', targets: KolumnEnum.VERIFIKAT }
			, { name: 'eu', targets: KolumnEnum.EU }
			, { name: 'kst', targets: KolumnEnum.KST, className: 'nw', visible: (harReskEllerFort ? false : true), searchable: (harReskEllerFort ? false : true) }
			, { name: 'proj', targets: KolumnEnum.PROJ, className: 'nw', visible: (harReskEllerFort ? false : true), searchable: (harReskEllerFort ? false : true) }
			, { name: 'reskfort', targets: KolumnEnum.RESKFORT, className: 'nw' , visible: (harReskEllerFort ? true : false), searchable: (harReskEllerFort ? true : false) }
			, { name: 'belopp', targets: KolumnEnum.BELOPP, className: 'hj' }
			, { name: 'saldo', targets: KolumnEnum.SALDO, className: 'hj' }
			// ----- Visas inte:
			, { name: 'isradtext', targets: KolumnEnum.ISRADTEXT, visible: false }
			, { name: 'radtext', targets: KolumnEnum.RADTEXT, visible: false }
		],

		createdRow(row, data, index) {

			/* Radtext-rad: */
			if (data[KolumnEnum.ISRADTEXT] === true) {

				// Styla hela raden (style vid hover av ovanliggande rad):
				row.classList.add('-underrad');

				/* Ändra värden i cellerna: 
				! Obs! Görs enklast *innan* celler tas bort nedan! */
				$('td', row).eq(KolumnEnum.DATUM).html('');
				$('td', row).eq(KolumnEnum.BESKRIVNING).html(dataTableData[index][KolumnEnum.RADTEXT]);
				/* Obs! De nedan måste ta hänsyn till kolumner som är visible:false! */
				$('td', row).eq(KolumnEnum.BELOPP - antalDoldaKolumner).html('');
				$('td', row).eq(KolumnEnum.SALDO - antalDoldaKolumner).html('');

				/* Ta bort kol 2–x (0–n):
					! Obs! Denna måste ta hänsyn till kolumner som är visible:false! */
				$('td', row)
					.filter(function (index) {
						return (index >= KolumnEnum.VERIFIKAT && index <= (KolumnEnum.RESKFORT - antalDoldaKolumner));
					})
					.remove();

				/* Sätt colspan på kol 1 (0–n):
					! Obs! Denna måste ta hänsyn till kolumner som är visible:false! */
				$('td', row).eq(KolumnEnum.BESKRIVNING)
					.attr('colspan', KolumnEnum.RESKFORT - KolumnEnum.BESKRIVNING + 1 - antalDoldaKolumner);

				/* Styla alla cellerna: */
				$('td', row).addClass('rt');
			}


			// Todo: Ev bort sen!!!!
			//if (index === 5)
			//{
			//	var api = this.api();

			//	//this.fnDraw();

			//	////api.row(row).child("Heyyyy "+data[0]).show();
			//	//api.draw();
			//}

		},
	});
};

let ssoKontoutdragDatatable = { 
	// Methods:
	initiera,
};

export { ssoKontoutdragDatatable };
